import React, { useContext } from "react";

import { ScrollNavigationContext } from "./ScrollNavigationContext";

interface ScrollNavigationContextType {
    registerSection: (id: string, el: HTMLElement) => void;
    scrollTo: (id: string) => void;
}

export const useScrollNavigation = (): ScrollNavigationContextType => {
    const context = useContext(ScrollNavigationContext);
    if (!context) {
        throw new Error("useScrollNavigation must be used within a ScrollNavigationProvider");
    }
    return context;
};
